<template>
  <div
    class="integrity-indicator"
    :style="{ fontSize: size + 'px', lineHeight: 1 }"
  >
    <span class="integrity-badge" :class="badgeClass">{{ percentage }}%</span>
  </div>
</template>

<script>
export default {
  name: "IntegrityIndicator",
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
  computed: {
    tagType() {
      const p = this.percentage;
      if (p <= 20) return "danger";
      if (p <= 40) return "warning";
      if (p <= 60) return "info";
      if (p <= 80) return "primary";
      return "success";
    },
    badgeClass() {
      return `integrity-badge--${this.tagType}`;
    },
  },
};
</script>

<style scoped>
.integrity-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.integrity-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  white-space: nowrap;
}

.integrity-badge--success {
  background-color: #dcfce7;
  color: #15803d;
  border-color: #bbf7d0;
}

.integrity-badge--primary {
  background-color: #e0f2fe;
  color: #0369a1;
  border-color: #bae6fd;
}

.integrity-badge--info {
  background-color: #fef9c3;
  color: #854d0e;
  border-color: #fef08a;
}

.integrity-badge--warning {
  background-color: #fef3c7;
  color: #b45309;
  border-color: #fde68a;
}

.integrity-badge--danger {
  background-color: #fee2e2;
  color: #b91c1c;
  border-color: #fecaca;
}
</style>
